import React, { useState } from 'react';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound from '@/components/ui/tables/IsLoadingNotFound';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import PermissionCheck from '@/components/common/PermissionCheck';

const DataTable = ({ isLoading, tableColumn, dataSource, totalRecord, dataFilter, onChangePage, deleteRecord }) => {
    const statusOptionList = [
        { value: 1, label: 'Pending' },
        { value: 2, label: 'Placed' },
        { value: 3, label: 'Accept' },
        { value: 4, label: 'Processing' },
        { value: 5, label: 'Out for delivery' },
        { value: 6, label: 'Delivered' },
        { value: 7, label: 'Canceled' },
        { value: 8, label: 'Rejected' },
        { value: 9, label: 'Returned' },
    ];

    return (
        <TableWrapServerSide tableColumnList={tableColumn} totalDataCount={totalRecord} initialPage={dataFilter?.page} onChangePage={onChangePage} per_page={dataFilter?.limit}>
            {dataSource.length > 0 ? (
                dataSource.map((data) => (
                    <tr className="db-table-body-tr" key={data._id}>
                        <td className="db-table-body-td">{data.order_serial_no}</td>
                        <td className="db-table-body-td">{data.order_type}</td>
                        <td className="db-table-body-td">{data?.user_id?.name}</td>
                        <td className="db-table-body-td">{data.total}</td>
                        <td className="db-table-body-td"> {Moment(data?.order_datetime).format('Y-M-D hh:mm:ss')}</td>
                        <td className="db-table-body-td">
                            {data.status && data.status == '1' ? (
                                <span className={'active'}>{statusOptionList.find((da) => da.value === data.status).label}</span>
                            ) : (
                                <span className={'inactive'}>{statusOptionList.find((da) => da.value === data.status).label}</span>
                            )}
                        </td>
                        <td className="db-table-body-td hidden-print hidden-print-remove">
                            <div className="flex justify-start items-center sm:items-start sm:justify-start gap-1.5">
                                <PermissionCheck permsission={'view_pos_orders'}>
                                    <Link to={`/admin/table-orders/show/${data._id}`}>
                                        <button className="db-table-action view">
                                            <i className="lab lab-view"></i>
                                            <span className="db-tooltip">view</span>
                                        </button>
                                    </Link>
                                </PermissionCheck>
                                <PermissionCheck permsission={'update_table_orders'}>
                                    <button className="db-table-action delete" onClick={() => deleteRecord(data._id)}>
                                        <i className="lab lab-delete"></i>
                                        <span className="db-tooltip">delete</span>
                                    </button>
                                </PermissionCheck>
                            </div>
                        </td>
                    </tr>
                ))
            ) : (
                <IsLoadingNotFound isLoading={isLoading} colSpan={tableColumn.length} />
            )}
        </TableWrapServerSide>
    );
};

export default DataTable;
